import { IExportOrdersParams } from '@app/models/interfaces';
import Api from '@app/services/api';
import { useExportDownload } from '@app/services/hooks/useExportDownload';

export const useExportQuery = () => {
  return useExportDownload<IExportOrdersParams>({
    downloadPrefix: 'orders',
    getFilePath: (filename) => `/orders/exported/${filename}`,
    mutationFn: (params) => Api.orders.exportOrders(params),
  });
};
